// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__19uXw","checkboxCol":"Table_checkboxCol__323fJ","emailCol":"Table_emailCol__2PhhJ","actionCol":"Table_actionCol__2TCUH"};